<template>
  <div v-if="comType == 'UI'">
    <el-carousel
      indicator-position="none"
      :height="`${comHeight}px`"
      :style="{
        'border-radius': `${radius}px`,
        margin: `${marginTop}px ${marginRight}px ${marginBottom}px ${marginLeft}px`,
      }"
    >
      <el-carousel-item v-for="(item, index) in imgUrlList" :key="index">
        <img :src="item.imgUrl" draggable="false" />
      </el-carousel-item>
    </el-carousel>
  </div>
  <div v-else-if="comType == 'config'">
    <el-form ref="form" label-width="100px" size="small">
      <div>
        <div>
          <el-form-item label="高度">
            <div class="slider-block">
              <el-slider v-model="comHeightValue" show-input :min="1" :max="750">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="圆角">
            <div class="slider-block">
              <el-slider v-model="radiusValue" show-input :min="0" :max="50"> </el-slider>
              <div class="set-radius">
                <el-popover placement="top" width="160" trigger="hover">
                  <radiusBox :radius="radiusValue"></radiusBox>
                  <el-button slot="reference">可见性</el-button>
                </el-popover>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="上间距">
            <div class="slider-block">
              <el-slider v-model="marginTopValue" show-input :min="-100" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="下间距">
            <div class="slider-block">
              <el-slider v-model="marginBottomValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="左间距">
            <div class="slider-block">
              <el-slider v-model="marginLeftValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
          <el-form-item label="右间距">
            <div class="slider-block">
              <el-slider v-model="marginRightValue" show-input :min="0" :max="100">
              </el-slider>
            </div>
          </el-form-item>
        </div>
      </div>
      <div>
        <div class="collapse-content">
          <el-collapse :value="activeName" size="small">
            <draggable v-model="imgUrlListValue">
              <el-collapse-item
                :name="index"
                :key="index"
                v-for="(item, index) in imgUrlListValue"
              >
                <template slot="title">
                  <el-form-item :label="`图片${index + 1}`">
                    <div class="collapse-title" @click.stop>
                      <jumpConfig :jumpLink.sync="item.jumpLink"></jumpConfig>
                      <el-button
                        type="default"
                        size="mini"
                        circle
                        @click.stop="deleteImgUrl(index)"
                      >
                        <i class="el-icon-delete"></i
                      ></el-button>
                    </div>
                  </el-form-item>
                </template>
                <el-form-item label="">
                  <customUpload :imageUrl.sync="item.imgUrl"></customUpload>
                  <div class="tip">图片建议比例：375*自定义高度</div>
                </el-form-item>
              </el-collapse-item>
            </draggable>
          </el-collapse>
          <div class="foot">
            <el-button type="default" size="small" plain @click="addNewImg"
              >添加背景图</el-button
            >
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import customUpload from "@/components/appltDecoration/customUpload";
import jumpConfig from "@/components/appltDecoration/jumpConfig";
import radiusBox from "@/components/appltDecoration/radiusBox";
export default {
  name: "comSwiper",
  props: {
    comType: {
      type: String,
      default: "UI",
    },
    imgUrlList: {
      type: Array,
      default: () => {
        return [
          {
            imgUrl: "",
            jumpLink: {
              type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
              remark: "",
            },
          },
        ];
      },
    },
    comHeight: {
      type: Number,
      default: 200,
    },
    marginTop: {
      type: Number,
      default: 0,
    },
    marginRight: {
      type: Number,
      default: 0,
    },
    marginBottom: {
      type: Number,
      default: 0,
    },
    marginLeft: {
      type: Number,
      default: 0,
    },
    radius: {
      type: Number,
      default: 0,
    },
  },
  components: {
    customUpload,
    jumpConfig,
    radiusBox,
    draggable,
  },
  computed: {
    imgUrlListValue: {
      get() {
        return this.imgUrlList;
      },
      set(val) {
        this.$emit(`update:imgUrlList`, val);
      },
    },
    comHeightValue: {
      get() {
        return this.comHeight;
      },
      set(val) {
        console.log("comHeight", val);
        this.$emit(`update:comHeight`, val);
      },
    },
    radiusValue: {
      get() {
        return this.radius;
      },
      set(val) {
        this.$emit(`update:radius`, val);
      },
    },
    marginTopValue: {
      get() {
        return this.marginTop;
      },
      set(val) {
        this.$emit(`update:marginTop`, val);
      },
    },
    marginRightValue: {
      get() {
        return this.marginRight;
      },
      set(val) {
        this.$emit(`update:marginRight`, val);
      },
    },
    marginBottomValue: {
      get() {
        return this.marginBottom;
      },
      set(val) {
        this.$emit(`update:marginBottom`, val);
      },
    },
    marginLeftValue: {
      get() {
        return this.marginLeft;
      },
      set(val) {
        this.$emit(`update:marginLeft`, val);
      },
    },
  },
  data() {
    return {
      activeName: [0],
    };
  },
  methods: {
    addNewImg() {
      this.activeName.push(this.imgUrlListValue.length);
      this.imgUrlListValue.push({
        imgUrl: "",
        jumpLink: {
          type: 1, // 1小程序页面，2跳转商品页，3跳转商品分组
          remark: "",
        },
      });
    },
    deleteImgUrl(index) {
      this.$confirm(`确定删除[图片${index + 1}]吗?`, "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(({ value }) => {
          this.imgUrlListValue.splice(index, 1);
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="less"></style>
